import { render, staticRenderFns } from "./CopyDocumentFieldsToDocuments.vue?vue&type=template&id=5e91eed3&scoped=true"
import script from "./CopyDocumentFieldsToDocuments.vue?vue&type=script&lang=js"
export * from "./CopyDocumentFieldsToDocuments.vue?vue&type=script&lang=js"
import style0 from "./CopyDocumentFieldsToDocuments.vue?vue&type=style&index=0&id=5e91eed3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e91eed3",
  null
  
)

export default component.exports